const RewardsStrings = {
  title: 'Cashback',
  screenLabel: 'This is Perks screen',
};

export default RewardsStrings;
